import React, { useState, useEffect } from 'react';
import { Phone, ChevronUp } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';
import { mockData } from '../mock';

const FloatingButtons = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsApp = () => {
    const message = `Hi! I'm interested in booking a consultation at ${mockData.clinic.name}.`;
    window.open(`https://wa.me/${mockData.clinic.whatsapp.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handleCall = () => {
    window.open(`tel:${mockData.clinic.phone}`, '_self');
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col space-y-4 items-center">
      {/* Scroll to Top Button */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="w-12 h-12 bg-sage text-white rounded-full flex items-center justify-center shadow-lg hover:bg-sage/90 transition-all duration-300 hover:scale-110"
          aria-label="Scroll to top"
        >
          <ChevronUp size={20} />
        </button>
      )}

      {/* WhatsApp Button */}
       <button
        onClick={handleWhatsApp}
        className="w-14 h-14 bg-green-500 text-white rounded-full flex items-center justify-center shadow-lg hover:bg-green-600 transition-all duration-300 hover:scale-110 group relative"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp size={24} /> {/* ✅ WhatsApp Icon */}
        <div className="absolute right-16 top-1/2 transform -translate-y-1/2 bg-primary text-white px-3 py-1 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          WhatsApp Us
        </div>
      </button>

      {/* Call Button */}
      <button
        onClick={handleCall}
        className="w-14 h-14 bg-[#3366ff] text-white rounded-full flex items-center justify-center shadow-lg hover:bg-[#5588ff] transition-all duration-300 hover:scale-110 group"
        aria-label="Call us"
      >
        <Phone size={24} />
        <div className="absolute right-16 top-1/2 transform -translate-y-1/2 bg-primary text-white px-3 py-1 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          Call Now
        </div>
      </button>
    </div>
  );
};

export default FloatingButtons;